import React, { useState } from "react";
import LiquidContainer from "./LiquidContainer";
import RecommendationItem from "./RecommendationItem";

const RecommendationSectionCard = ({ section }) => {
  const [open, setOpen] = useState(false);

  return (
    <LiquidContainer backgroundColor="#ffffff" radius="10px">
      <div className="p-3">

        {/* HEADER (Clickable) */}
        <div
          className="d-flex justify-content-between align-items-center cursor-pointer"
          onClick={() => setOpen(!open)}
          style={{ cursor: "pointer" }}
        >
          <h4 className="m-0">{section.title}</h4>
          <span
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "0.3s ease",
              fontSize: "18px"
            }}
          >
            ▼
          </span>
        </div>

        {/* COLLAPSIBLE CONTENT */}
        <div
          style={{
            maxHeight: open ? "2000px" : "0px",
            overflow: "hidden",
            transition: "max-height 0.4s ease",
          }}
        >
          {open && (
            <div className="mt-3">
              {section.items?.map((item, index) => (
                <RecommendationItem key={index} item={item} />
              ))}
            </div>
          )}
        </div>

      </div>
    </LiquidContainer>
  );
};

export default RecommendationSectionCard;
